import React from 'react';
import TopNav from '../nav/topnav';
import BottomNav from '../nav/bottomnav';
import { TeamContext } from '../context/TeamContext';
import { useContext } from 'react';

const Layout: React.FC<{ children: any | null }> = ({ children }) => {

    const { teamSelected } = useContext(TeamContext);

    return (
        <div className="layout">
            {/* Top Navigation */}
            <TopNav teamSelected={teamSelected}  />

            {/* Main Content */}
            <div className="main-content">
                {children}
            </div>

            {/* Bottom Navigation */}
            <BottomNav />
        </div>
    );
};

export default Layout;